import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const photoSrc = (p) => (p.storage_path ? `${API}/files/${p.storage_path}` : p.url);

export function formatApiError(detail, fallback = "Etwas ist schiefgelaufen. Bitte erneut versuchen.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
